export default {
  defaultStyle: {
    padding: '15px 10px 0',
    '&$filterAvail':{
      padding: 'unset',
    },
    '@media (min-width: 801px)': {
      padding: '15px 20px 0',
    }
  },
  alertContainer: {
    background: '#fff',
    borderTop: data => '3px solid ' + data.mainColor,
    border: '1px solid #d8d8d8',
    padding: '20px',
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    '@media (min-width: 801px)': {
      display: 'table',
      width: '100%',
      boxSizing: 'border-box',
      maxWidth: '1170px',
      margin: '0 auto'
    },
    '&:lang(ar)':{
      direction: 'rtl',
    }
  },
  alertSubcontainer: {
    '@media (max-width: 800px)': {
      display: 'flex',
      flexDirection: 'row',
      gap: '10px',
      alignItems: 'center',
      padding: '20px',
    }
  },
  alertIcon: {
    display: 'block',
    textAlign: 'center',
    '@media (min-width: 801px)': {
      display: 'table-cell',
      verticalAlign: 'middle',
      width: '35px'
    },
  },
  alertText: {
    margin: '10px 0',
    '@media (min-width: 801px)': {
      display: 'table-cell',
      verticalAlign: 'middle',
      width: '800px',
      margin: '0'
    },
    '@media (max-width: 800px)': {
      '& > div':{
        display: 'flex',
        flexDirection: 'column'
      }
    }
  },
  alertButton: {
    paddingTop: '10px',
    '@media (min-width: 801px)': {
      display: 'table-cell',
      verticalAlign: 'middle',
      width: '200px',
      padding: '0'
    }
  },
  noDispoCalendarContainer:{
    marginTop:'20px',
    marginBottom:'20px',
    border: '1px solid #d8d8d8',
    '@media (min-width: 801px)': {
      boxSizing: 'border-box',
      maxWidth: '1170px',
      margin: '20px auto 0',
      background:'#fff',
    },
    '& > div':{
      '& > div':{
        backround:'transparent'
      }
    }
  },
  AvailDatepickerCalendar:{
    paddingBotton:'20px'
  },
  dateChangeButton:{
    textAlign:'right',
    padding:'0 10px 10px',
    '@media(min-width:801px)':{
      padding:'20px 35px 20px',
      borderTop:'1px solid #d8d8d8'
    }  
  },
  availRoomDetailTabButton: {
    position: 'absolute',
    right: '20px',
    top: '78%',
    '@media (min-width:801px)': {
      right: '30px'
    },
    '&:lang(ar)': {
      right: 'auto',
      left: '20px',
      '@media (min-width:801px)': {
        left: '30px',
        right: 'auto'
      },
    }
  },
  alternativeDispoContainer: {
    marginTop: '10px',
    padding: ' 20px 0 10px 0',
    fontSize: '10px',
    display: 'flex',
    flexDirection: 'row',
    gap: '5px',
    '@media (min-width: 801px)': {
      width: '100%',
      padding: '0 10px 10px 0',
      boxSizing: 'border-box',
      maxWidth: '1170px',
      margin: '0 auto',
      marginTop: '50px'
    }
  },
  slideContainer: {
    '& .nestedMultiContent': {
      display: 'flex',
      transition: 'margin-left 0.5s ease',
    },
    '& .nestedMultiContent > *:last-child': {
      marginRight: '2px',
    },
    '& .nestedMultiContent > *:not(:last-child)': {
      marginRight: '45px',
    },
    '@media(min-width: 901px)': {
      '.nestedMultiContent > *:not(:last-child)': {
        marginRight: '50px',
      }
    },
    '& .wrapperMultiContent': {
      width: '100%',
      overflow: 'hidden',
      paddingBottom: '10px',

    },
    '@media (min-width: 801px)': {
      width: 'calc(100% - 40px)',
      margin: '10px auto 0',
    },
    maxWidth: '1170px',
    margin: '0 auto 0',
    position: 'relative',

    '& $topButton': {
      display: 'flex',
      justifyContent: 'center',
      top: '45%',
      right: '-35px',
    },

    '& $botButton': {
      display: 'flex',
      justifyContent: 'center',
      top: '45%',
      left: '-35px',
    },
  },
  topButton: {
    width: '40px',
    height: '40px',
    bottom: '100%',
    position: 'absolute',
    right: '0',
    borderBottom: '1px solid #fff',
    borderBottomColor: 'rgba(255,255,255,0.6)',
    top: 'auto',
    marginTop: '0',
    zIndex:501,
    '& > span': {
      borderBottomColor: 'rgba(255,255,255,0.6)',
      fontSize: '11px'
    },
    '&:lang(ar)': {
      right: 'auto',
      left: 0
    },
    '&.disabled' : {
      opacity: '0.3',
      pointerEvents: 'none'
    }
  },
  botButton: {
    width: '40px',
    height: '40px',
    position: 'absolute',
    right: '0',
    bottom: '100%',
    left: 'auto',
    marginTop: '0',
    zIndex:501,
    '& > span': {
      borderBottomColor: 'rgba(255,255,255,0.6)',
      fontSize: '11px'
    },
    '&:lang(ar)': {
      right: 'auto',
      left: 0
    },
    '&.disabled' : {
      opacity: '0.3',
      pointerEvents: 'none'
    }
  },
  disabledButton: {
    display: 'none !important',
    //opacity: '0.3 !important',
    //pointerEvents: 'none !important'
  },
  removePadding: {
    padding: '0'
  },
  filterAvail:{}
};
